// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3AJK8","empty":"ModalGraph_empty__ht1t4"};